import apiFetch from "@wordpress/api-fetch";

const URL_REGEX =
	/\b((https?|ftp|file):\/\/|(www|ftp)\.)[-A-Z0-9+&@#\/%?=~_|$!:,.;]*[A-Z0-9+&@#\/%=~_|$]/gi;

const saveImagesLocally = async (content = "") => {
	let allUrls = [...content.matchAll(URL_REGEX)];
	const urls = allUrls
		.map((url) => url.at(0) ?? "")
		.filter((url, idx, arr) => arr.indexOf(url) === idx)
		.filter((url) => /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url));

	if (!urls.length) {
		return content;
	}

	const requests = urls.map((url) =>
		apiFetch<{
			sourceURL: string;
			url: string;
		}>({
			path: "/blockart/v1/image-import",
			method: "POST",
			data: {
				url: url,
			},
		})
	);

	const response = await Promise.allSettled(requests);

	for (const res of response) {
		if ("fulfilled" === res.status) {
			const { sourceURL, url } = res.value;
			if (url) {
				content = content.replaceAll(sourceURL, url);
			}
		}
	}

	return content;
};

export default saveImagesLocally;
